module.exports = "function cellSizeAndPositionGetter ({ index }) {\n  const item = itemsArray[index]\n\n  return {\n    height: item.size,\n    width: item.size,\n    x: item.left,\n    y: item.top\n  }\n}\n\nfunction cellRenderer ({ index, key, style }) {\n  return (\n    <div\n      key={key}\n      style={style}\n    >\n      {itemsArray[index].name}\n    </div>\n  )\n}\n\nfunction renderCollection (props) {\n  return (\n    <Collection\n      cellCount={itemsArray.length}\n      cellRenderer={cellRenderer}\n      cellSizeAndPositionGetter={cellSizeAndPositionGetter}\n    />\n  )\n}\n"


/*****************
 ** WEBPACK FOOTER
 ** ./~/raw-loader!./examples/collection.js
 ** module id = 364
 ** module chunks = 0
 **/